export default __webpack_public_path__ + "static/img_1_0-9cc2811ff64d972ae48c57f2d861b316.jpg";